// src/jurisdictions/helpers.ts
var isNoticeProvided = (value) => value === 1;
var isUserConsented = (value) => value === 2;
var allNoticesProvided = (notices) => Object.values(notices).every((notice) => isNoticeProvided(notice));
var allSignalsConsented = (consentSignals) => Object.values(consentSignals).every((signal) => {
  if (Array.isArray(signal)) {
    return signal.every((el) => isUserConsented(el));
  }
  return isUserConsented(signal);
});

// src/jurisdictions/getCaliforniaConsent.ts
var getCaliforniaConsent = (pingData) => {
  const { parsedSections: { uscav1: californiaSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.Gpc === "boolean" && typeof input2.GpcSegmentType === "number" && (Array.isArray(input2.KnownChildSensitiveDataConsents) && input2.KnownChildSensitiveDataConsents.every((elem) => typeof elem === "number")) && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.PersonalDataConsents === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && typeof input2.SensitiveDataLimitUseNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SharingOptOut === "number" && typeof input2.SharingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(californiaSection)) {
    const notices = {
      saleOptOutNotice: californiaSection.SaleOptOutNotice,
      sharingOptOutNotice: californiaSection.SharingOptOutNotice
    };
    const consentSignals = {
      sale: californiaSection.SaleOptOut,
      sharing: californiaSection.SharingOptOut
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/jurisdictions/getColoradoConsent.ts
var getColoradoConsent = (pingData) => {
  const { parsedSections: { uscov1: coloradoSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.KnownChildSensitiveDataConsents === "number" && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SharingNotice === "number" && typeof input2.TargetedAdvertisingOptOut === "number" && typeof input2.TargetedAdvertisingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(coloradoSection)) {
    const notices = {
      saleOptOutNotice: coloradoSection.SaleOptOutNotice,
      targetedAdvertisingNotice: coloradoSection.TargetedAdvertisingOptOutNotice
    };
    const consentSignals = {
      sale: coloradoSection.SaleOptOut,
      targetedAdvertising: coloradoSection.TargetedAdvertisingOptOut
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/jurisdictions/getConnecticutConsent.ts
var getConnecticutConsent = (pingData) => {
  const { parsedSections: { usctv1: ConnecticutSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => Array.isArray(input2.KnownChildSensitiveDataConsents) && input2.KnownChildSensitiveDataConsents.every((elem) => typeof elem === "number") && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SharingNotice === "number" && typeof input2.TargetedAdvertisingOptOut === "number" && typeof input2.TargetedAdvertisingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(ConnecticutSection)) {
    const notices = {
      saleOptOutNotice: ConnecticutSection.SaleOptOutNotice,
      targetedAdvertisingNotice: ConnecticutSection.TargetedAdvertisingOptOutNotice
    };
    const consentSignals = {
      sale: ConnecticutSection.SaleOptOut,
      targetedAdvertising: ConnecticutSection.TargetedAdvertisingOptOut
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/jurisdictions/getGDPRConsent.ts
var getGDPRConsent = (pingData, vendorId, requiredPurposes) => {
  const { parsedSections: { tcfeuv2: gdprSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.CmpId === "number" && typeof input2.CmpVersion === "number" && typeof input2.ConsentLanguage === "string" && typeof input2.ConsentScreen === "number" && input2.Created instanceof Date && typeof input2.IsServiceSpecific === "boolean" && input2.LastUpdated instanceof Date && typeof input2.NumCustomPurposes === "number" && typeof input2.PolicyVersion === "number" && (Array.isArray(input2.PublisherConsents) && input2.PublisherConsents.every((elem) => typeof elem === "boolean")) && typeof input2.PublisherCountryCode === "string" && (Array.isArray(input2.PublisherCustomConsents) && input2.PublisherCustomConsents.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PublisherCustomLegitimateInterests) && input2.PublisherCustomLegitimateInterests.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PublisherLegitimateInterests) && input2.PublisherLegitimateInterests.every((elem) => typeof elem === "boolean")) && typeof input2.PublisherPurposesSegmentType === "number" && true && (Array.isArray(input2.PurposeConsents) && input2.PurposeConsents.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PurposeLegitimateInterests) && input2.PurposeLegitimateInterests.every((elem) => typeof elem === "boolean")) && typeof input2.PurposeOneTreatment === "boolean" && (Array.isArray(input2.SpecialFeatureOptins) && input2.SpecialFeatureOptins.every((elem) => typeof elem === "boolean")) && typeof input2.UseNonStandardStacks === "boolean" && (Array.isArray(input2.VendorConsents) && input2.VendorConsents.every((elem) => typeof elem === "number")) && (Array.isArray(input2.VendorLegitimateInterests) && input2.VendorLegitimateInterests.every((elem) => typeof elem === "number")) && typeof input2.VendorListVersion === "number" && (Array.isArray(input2.VendorsAllowed) && input2.VendorsAllowed.every((elem) => typeof elem === "number")) && typeof input2.VendorsAllowedSegmentType === "number" && (Array.isArray(input2.VendorsDisclosed) && input2.VendorsDisclosed.every((elem) => typeof elem === "number")) && typeof input2.VendorsDisclosedSegmentType === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(gdprSection)) {
    const { VendorConsents: vendorConsents, PurposeConsents: purposeConsents } = gdprSection;
    const isVendorConsented = vendorConsents.includes(vendorId);
    const arePurposesConsented = requiredPurposes.every((purposeId) => purposeConsents[purposeId - 1]);
    return isVendorConsented && arePurposesConsented;
  }
  return false;
};
var getGDPRPublisherConsent = (pingData, purposes) => {
  const { parsedSections: { tcfeuv2: gdprSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.CmpId === "number" && typeof input2.CmpVersion === "number" && typeof input2.ConsentLanguage === "string" && typeof input2.ConsentScreen === "number" && input2.Created instanceof Date && typeof input2.IsServiceSpecific === "boolean" && input2.LastUpdated instanceof Date && typeof input2.NumCustomPurposes === "number" && typeof input2.PolicyVersion === "number" && (Array.isArray(input2.PublisherConsents) && input2.PublisherConsents.every((elem) => typeof elem === "boolean")) && typeof input2.PublisherCountryCode === "string" && (Array.isArray(input2.PublisherCustomConsents) && input2.PublisherCustomConsents.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PublisherCustomLegitimateInterests) && input2.PublisherCustomLegitimateInterests.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PublisherLegitimateInterests) && input2.PublisherLegitimateInterests.every((elem) => typeof elem === "boolean")) && typeof input2.PublisherPurposesSegmentType === "number" && true && (Array.isArray(input2.PurposeConsents) && input2.PurposeConsents.every((elem) => typeof elem === "boolean")) && (Array.isArray(input2.PurposeLegitimateInterests) && input2.PurposeLegitimateInterests.every((elem) => typeof elem === "boolean")) && typeof input2.PurposeOneTreatment === "boolean" && (Array.isArray(input2.SpecialFeatureOptins) && input2.SpecialFeatureOptins.every((elem) => typeof elem === "boolean")) && typeof input2.UseNonStandardStacks === "boolean" && (Array.isArray(input2.VendorConsents) && input2.VendorConsents.every((elem) => typeof elem === "number")) && (Array.isArray(input2.VendorLegitimateInterests) && input2.VendorLegitimateInterests.every((elem) => typeof elem === "number")) && typeof input2.VendorListVersion === "number" && (Array.isArray(input2.VendorsAllowed) && input2.VendorsAllowed.every((elem) => typeof elem === "number")) && typeof input2.VendorsAllowedSegmentType === "number" && (Array.isArray(input2.VendorsDisclosed) && input2.VendorsDisclosed.every((elem) => typeof elem === "number")) && typeof input2.VendorsDisclosedSegmentType === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(gdprSection)) {
    const { PublisherConsents: publisherConsents } = gdprSection;
    const arePublisherPurposesConsented = purposes.every((purposeId) => publisherConsents[purposeId - 1]);
    return arePublisherPurposesConsented;
  }
  return false;
};

// src/jurisdictions/getUSNationalConsent.ts
var getUSNationalConsent = (pingData) => {
  const { parsedSections: { usnatv1: usaNationalSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.Gpc === "boolean" && typeof input2.GpcSegmentType === "number" && (Array.isArray(input2.KnownChildSensitiveDataConsents) && input2.KnownChildSensitiveDataConsents.every((elem) => typeof elem === "number")) && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.PersonalDataConsents === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && typeof input2.SensitiveDataLimitUseNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SensitiveDataProcessingOptOutNotice === "number" && typeof input2.SharingNotice === "number" && typeof input2.SharingOptOut === "number" && typeof input2.SharingOptOutNotice === "number" && typeof input2.TargetedAdvertisingOptOut === "number" && typeof input2.TargetedAdvertisingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(usaNationalSection)) {
    const notices = {
      saleOptOutNotice: usaNationalSection.SaleOptOutNotice,
      sensitiveDataProcessingOptOutNotice: usaNationalSection.SensitiveDataProcessingOptOutNotice
    };
    const consentSignals = {
      sale: usaNationalSection.SaleOptOut,
      sharing: usaNationalSection.SharingOptOut,
      targetedAdvertising: usaNationalSection.TargetedAdvertisingOptOut
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/jurisdictions/getUtahConsent.ts
var getUtahConsent = (pingData) => {
  const { parsedSections: { usutv1: utahSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.KnownChildSensitiveDataConsents === "number" && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SensitiveDataProcessingOptOutNotice === "number" && typeof input2.SharingNotice === "number" && typeof input2.TargetedAdvertisingOptOut === "number" && typeof input2.TargetedAdvertisingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(utahSection)) {
    const notices = {
      saleOptOutNotice: utahSection.SaleOptOutNotice,
      targetedAdvertisingNotice: utahSection.TargetedAdvertisingOptOutNotice,
      sensitiveDataProcessingOptOutNotice: utahSection.SensitiveDataProcessingOptOutNotice
    };
    const consentSignals = {
      sale: utahSection.SaleOptOut,
      targetedAdvertising: utahSection.TargetedAdvertisingOptOut,
      sensitiveDataProcessing: utahSection.SensitiveDataProcessing
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/jurisdictions/getVirginiaConsent.ts
var getVirginiaConsent = (pingData) => {
  const { parsedSections: { usvav1: virginiaSection } } = pingData;
  if (((input) => {
    const $io0 = (input2) => typeof input2.KnownChildSensitiveDataConsents === "number" && typeof input2.MspaCoveredTransaction === "number" && typeof input2.MspaOptOutOptionMode === "number" && typeof input2.MspaServiceProviderMode === "number" && typeof input2.SaleOptOut === "number" && typeof input2.SaleOptOutNotice === "number" && (Array.isArray(input2.SensitiveDataProcessing) && input2.SensitiveDataProcessing.every((elem) => typeof elem === "number")) && typeof input2.SharingNotice === "number" && typeof input2.TargetedAdvertisingOptOut === "number" && typeof input2.TargetedAdvertisingOptOutNotice === "number" && typeof input2.Version === "number";
    return typeof input === "object" && input !== null && $io0(input);
  })(virginiaSection)) {
    const notices = {
      saleOptOutNotice: virginiaSection.SaleOptOutNotice,
      targetedAdvertisingNotice: virginiaSection.TargetedAdvertisingOptOutNotice
    };
    const consentSignals = {
      sale: virginiaSection.SaleOptOut,
      targetedAdvertising: virginiaSection.TargetedAdvertisingOptOut
    };
    return allNoticesProvided(notices) && allSignalsConsented(consentSignals);
  }
  return false;
};

// src/checkers.ts
var publisherCheckers = {
  2: getGDPRPublisherConsent,
  7: getUSNationalConsent,
  8: getCaliforniaConsent,
  9: getVirginiaConsent,
  10: getColoradoConsent,
  11: getUtahConsent,
  12: getConnecticutConsent
};
var vendorCheckers = {
  2: getGDPRConsent,
  7: getUSNationalConsent,
  8: getCaliforniaConsent,
  9: getVirginiaConsent,
  10: getColoradoConsent,
  11: getUtahConsent,
  12: getConnecticutConsent
};
var sectionIdLookup = (supportedAPIs, parsedSectionId) => {
  const lookup = supportedAPIs.reduce((acc, item) => {
    const [value, key] = item.split(":");
    acc[key] = Number.parseInt(value);
    return acc;
  }, {});
  return lookup[parsedSectionId];
};
function getRelevantCheckerFuncs(pingData, isVendorChecker) {
  if (pingData.applicableSections.length > 0) {
    return pingData.applicableSections.filter((id) => id > 0).map((id) => isVendorChecker ? vendorCheckers[id] : publisherCheckers[id]);
  }
  return Object.keys(pingData.parsedSections).map((id) => sectionIdLookup(pingData.supportedAPIs, id)).map((id) => isVendorChecker ? vendorCheckers[id] : publisherCheckers[id]);
}

// src/index.ts
var pingData;
var resolveConsentSignal;
var defaultPurposes = Array.from({ length: 11 }, (_, i) => i + 1);
var consentSignalReady = (pingData2) => {
  const { signalStatus, applicableSections, parsedSections } = pingData2;
  const noJurisdictionsApply = applicableSections[0] <= 0;
  const hasParsedJurisdictions = Object.keys(parsedSections).length > 0;
  return signalStatus === "ready" && (hasParsedJurisdictions || noJurisdictionsApply);
};
var consentSignalPromise = new Promise((resolve) => {
  resolveConsentSignal = resolve;
});
var gppEventCallback = (data, success) => {
  if (((input) => {
    const $io0 = (input2) => typeof input2.eventName === "string" && typeof input2.listenerId === "number" && true && (typeof input2.pingData === "object" && input2.pingData !== null && $io1(input2.pingData));
    const $io1 = (input2) => typeof input2.gppVersion === "string" && (input2.cmpStatus === "error" || input2.cmpStatus === "loaded" || input2.cmpStatus === "loading" || input2.cmpStatus === "stub") && (input2.cmpDisplayStatus === "disabled" || input2.cmpDisplayStatus === "hidden" || input2.cmpDisplayStatus === "visible") && (input2.signalStatus === "not ready" || input2.signalStatus === "ready") && (Array.isArray(input2.supportedAPIs) && input2.supportedAPIs.every((elem) => typeof elem === "string")) && typeof input2.cmpId === "number" && (Array.isArray(input2.sectionList) && input2.sectionList.every((elem) => typeof elem === "number")) && (Array.isArray(input2.applicableSections) && input2.applicableSections.every((elem) => typeof elem === "number")) && typeof input2.gppString === "string" && true;
    return typeof input === "object" && input !== null && $io0(input);
  })(data)) {
    if (!success) {
      console.error("failed to process addEventListener command");
    }
    if (data.pingData.cmpStatus === "error") {
      console.error("CMP error");
    }
    if (consentSignalReady(data.pingData)) {
      pingData = data.pingData;
      resolveConsentSignal();
    }
  }
};
var isVendorConsented = (vendorId, purposes = defaultPurposes) => {
  if (!((input) => {
    const $io0 = (input2) => typeof input2.gppVersion === "string" && (input2.cmpStatus === "error" || input2.cmpStatus === "loaded" || input2.cmpStatus === "loading" || input2.cmpStatus === "stub") && (input2.cmpDisplayStatus === "disabled" || input2.cmpDisplayStatus === "hidden" || input2.cmpDisplayStatus === "visible") && (input2.signalStatus === "not ready" || input2.signalStatus === "ready") && (Array.isArray(input2.supportedAPIs) && input2.supportedAPIs.every((elem) => typeof elem === "string")) && typeof input2.cmpId === "number" && (Array.isArray(input2.sectionList) && input2.sectionList.every((elem) => typeof elem === "number")) && (Array.isArray(input2.applicableSections) && input2.applicableSections.every((elem) => typeof elem === "number")) && typeof input2.gppString === "string" && true;
    return typeof input === "object" && input !== null && $io0(input);
  })(pingData)) {
    return false;
  }
  const vendorIds = Array.isArray(vendorId) ? vendorId : [vendorId];
  const checkerFuncs = getRelevantCheckerFuncs(pingData, true);
  return vendorIds.every((id) => checkerFuncs.every((fn) => fn(pingData, id, purposes)));
};
var waitForVendorConsent = async (vendorId, purposes = defaultPurposes) => {
  await consentSignalPromise;
  return isVendorConsented(vendorId, purposes);
};
var arePublisherPurposesConsented = (pingData2, purposes = defaultPurposes) => {
  const checkerFns = getRelevantCheckerFuncs(pingData2, false);
  const result = checkerFns.every((fn) => fn(pingData2, purposes));
  return result;
};
var isPublisherConsented = (purposes = defaultPurposes) => ((input) => {
  const $io0 = (input2) => typeof input2.gppVersion === "string" && (input2.cmpStatus === "error" || input2.cmpStatus === "loaded" || input2.cmpStatus === "loading" || input2.cmpStatus === "stub") && (input2.cmpDisplayStatus === "disabled" || input2.cmpDisplayStatus === "hidden" || input2.cmpDisplayStatus === "visible") && (input2.signalStatus === "not ready" || input2.signalStatus === "ready") && (Array.isArray(input2.supportedAPIs) && input2.supportedAPIs.every((elem) => typeof elem === "string")) && typeof input2.cmpId === "number" && (Array.isArray(input2.sectionList) && input2.sectionList.every((elem) => typeof elem === "number")) && (Array.isArray(input2.applicableSections) && input2.applicableSections.every((elem) => typeof elem === "number")) && typeof input2.gppString === "string" && true;
  return typeof input === "object" && input !== null && $io0(input);
})(pingData) ? arePublisherPurposesConsented(pingData, purposes) : false;
var waitForPublisherConsent = async (purposes = defaultPurposes) => {
  await consentSignalPromise;
  return isPublisherConsented(purposes);
};
var waitForGPP = () => {
  return new Promise((resolve) => {
    const loop = () => typeof globalThis.__gpp === "function" ? resolve() : setTimeout(loop, 10);
    loop();
  });
};
var init = async () => {
  await waitForGPP();
  globalThis.__gpp("addEventListener", gppEventCallback);
};
init();
export {
  waitForVendorConsent,
  waitForPublisherConsent,
  isVendorConsented,
  isPublisherConsented,
  init,
  defaultPurposes
};

//# debugId=BFF99DF075A9F9E664756E2164756E21
